import * as React from 'react';

export default function ChargingType({...rest}) {
  return (
    <svg
      {...rest}
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0387 2.87551H13.8984V1.01888H14.7851V2.85221H15.4252V4.55221C15.4252 5.49555 14.6616 6.26888 13.7085 6.26888H13.2219C12.2785 6.26888 11.5052 5.50524 11.5052 4.55221V2.85221H12.152V1.01888H13.0387V2.87551ZM12.3919 3.76218V4.55221C12.3919 5.01252 12.7652 5.38221 13.2219 5.38221H13.7085C14.1689 5.38221 14.5385 5.00888 14.5385 4.55221V3.76218H12.3919Z"
        fill="#001E50"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.85641 1.38667C1.63459 1.38667 1.45307 1.56818 1.45307 1.79V13.6133H9.01307V1.79C9.01307 1.56818 8.83156 1.38667 8.60974 1.38667H1.85641ZM0.566406 1.79C0.566406 1.07849 1.14489 0.5 1.85641 0.5H8.60974C9.32125 0.5 9.89974 1.07849 9.89974 1.79V7.03286H10.662C11.3655 7.03286 11.9136 7.62409 11.9136 8.31393V11.7061C11.9136 12.2477 12.3188 12.2975 12.4718 12.2967C12.6249 12.2959 13.0345 12.2607 13.0345 11.7061V7.00739H13.9212V11.7061C13.9212 12.9164 13.0345 13.1826 12.4718 13.1826C11.9136 13.1826 11.027 12.9164 11.027 11.7061V8.31393C11.027 8.08364 10.8462 7.91953 10.662 7.91953H9.89974V14.5H0.566406V1.79Z"
        fill="#001E50"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.09973 6.87974L5.02639 7.2264L4.33306 9.4464C4.30639 9.5064 4.33306 9.57307 4.38639 9.59974C4.44639 9.6264 4.51306 9.59974 4.53973 9.5464L6.53973 6.85307C6.65963 6.70553 6.59381 6.48517 6.40639 6.4264L5.41973 6.05307L5.99973 3.7864C6.01306 3.73307 5.97973 3.67307 5.93306 3.65307C5.87973 3.63307 5.81973 3.6464 5.78639 3.6864L3.95973 6.4664C3.86319 6.64237 3.89457 6.79862 4.09973 6.87974Z"
        fill="#001E50"
      />
    </svg>
  );
}
